export function isoToDatetimeLocal(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function datetimeLocalToIso(localVal: string): string | null {
  const t = localVal.trim();
  if (!t) return null;
  const d = new Date(t);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

/** For split date+time fields (reliable on iOS vs <input type="datetime-local">). */
export function isoToDateAndTime(iso: string | null): { date: string; time: string } {
  if (!iso) return { date: '', time: '' };
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return { date: '', time: '' };
  const p = (n: number) => String(n).padStart(2, '0');
  return {
    date: `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`,
    time: `${p(d.getHours())}:${p(d.getMinutes())}`,
  };
}

export function dateAndTimeToIso(dateVal: string, timeVal: string): string | null {
  const date = dateVal.trim();
  const time = timeVal.trim();
  if (!date || !time) return null;
  const hm = time.length >= 5 ? time.slice(0, 5) : time;
  const d = new Date(`${date}T${hm}`);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
